import { Box, Button, TextField } from '@mui/material';
import BasicModal from '../../../common/BasicModal';
import { useTranslation } from 'react-i18next';
import { Dispatch, FC, SetStateAction, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import IResponse from '../../../../interfaces/response';
import { ICampaign, IMedia } from '../../../../interfaces/campaign';
import { CampaignContext } from '../../../../contexts/CampaignContext';
import InstagramSerialStory from '../../../common/InstagramSerialStory';

type ShowModaCampaignProps = {
	open: boolean;
	status: string;
	id: number | undefined;
	showBtn?: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
};

const ShowModalCampaign: FC<ShowModaCampaignProps> = ({ open, setOpen, status, id, showBtn = true }) => {
	let { fetchedMedias, setSelectedPlatform } = useContext(CampaignContext);
	let { t } = useTranslation();
	const handleCloseDeleteDialog = () => {
		setOpen(!open);
	};
	let [data, setData] = useState<ICampaign | null>(null);
	let [rejectTitle, setRejectTitle] = useState<string>('');
	let [rejectReason, setRejectReason] = useState<string>('');
	const [previewData, setPreviewData] = useState<IMedia | null | undefined>(null);
	let api = status === 'reject' ? 'reject' : 'update-status';
	useEffect(() => {
		if (id) {
			axios<IResponse<ICampaign>>({
				method: 'get',
				url: `admin/campaigns/${id}`,
			}).then(res => {
				if (res.data.success) {
					let result = res.data.data;
					let filterMedia = fetchedMedias?.find(item => item.system_name === result.media);
					setSelectedPlatform(filterMedia?.system_name || null);
					setData(result);
					setPreviewData(filterMedia || null);
				}
			});
		}
	}, [open]);
	let handleSubmit = () => {
		axios<IResponse<any>>({
			method: status === 'reject' ? 'post' : 'put',
			url: `admin/campaigns/${api}/${id}`,
			data:
				status === 'reject'
					? {
							reject_title: rejectTitle,
							reject_reason: rejectReason,
						}
					: { status: 'queue_up' },
		}).then(() => {
			setOpen(false);
		});
	};
	return (
		<BasicModal
			open={!!open}
			onClose={handleCloseDeleteDialog}
			title={status === 'reject' ? t('campaign-rejection-reason') : ''}
			titleClassName={'text-center grow '}
			subClassName={'flex flex-row-reverse'}
			className={'max-w-sm rounded-lg'}
			showBackIcon={false}
			action={
				showBtn && (
					<Box className="w-full">
						<div className="flex justify-around">
							<Button onClick={handleSubmit} className="mx-2 w-1/2" color="primary">
								{t('register')}
							</Button>
							<Button onClick={handleCloseDeleteDialog} className="mx-2 w-1/2" color="error">
								{t('cancel')}
							</Button>
						</div>
					</Box>
				)
			}
		>
			{status === 'reject' ? (
				<Box className="mt-5">
					<TextField onChange={e => setRejectTitle(e.target.value)} className="my-2 w-full" label={t('title')} />
					<TextField onChange={e => setRejectReason(e.target.value)} label={t('rejection_reason')} className="my-2 w-full" multiline rows={5} maxRows={4} />
				</Box>
			) : (
				<Box className="flex flex-col justify-center">
					<div className="flex items-center justify-between">
						<span className="h-0.5 w-full border"></span>
						<p className="m-3 text-center text-lg">{previewData && previewData.title}</p>
						<span className="h-0.5 w-full border"></span>
					</div>
					<InstagramSerialStory type="image" file={data?.contents && data?.contents.length > 0 ? data?.contents[0].images : []} previewImage={true} />
				</Box>
			)}
		</BasicModal>
	);
};

export default ShowModalCampaign;
